module.exports = __webpack_public_path__ + "static/media/chef-curated-multicuisine.d1b7b6e6.webp";